var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _ellipse, _path67, _path68, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#046a38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,13.125h30v1.875H0v-1.875ZM13.125,7.5h1.875v15h-1.875V7.5Z",
    style: {
      fill: "#ffcd00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,15h30v1.875H0v-1.875ZM15,7.5h1.875v15h-1.875V7.5Z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,14.375h30v1.25H0v-1.25ZM14.375,7.5h1.25v15h-1.25V7.5Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 3.75,
    style: {
      fill: "#d50032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M15,11.665l.117.361h.379l-.307.223.117.361-.306-.223-.307.223.117-.361-.307-.223h.379l.118-.361Z",
    style: {
      fill: "#046a38"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.331,12.643l-.331-.241-.331.24.126-.389-.331-.24h.409l.127-.388.126.389h.409l-.331.24.127.389ZM14.542,12.039l.283.206-.108.333.283-.207.283.206-.108-.333.283-.206h-.35l-.108-.332-.108.333h-.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M16.96,12.302l-.117.361.307.223h-.38l-.117.361-.117-.361h-.379l.307-.223-.117-.361.307.223.306-.223Z",
    style: {
      fill: "#046a38"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.653,13.287l-.126-.389h-.409l.331-.24-.126-.389.331.24.331-.24-.126.389.331.24h-.409l-.128.389ZM16.195,12.873h.35l.108.333.108-.333h.35l-.283-.206.108-.333-.283.206-.283-.206.108.333-.283.206Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M18.171,13.97l-.307.223.117.361-.307-.223-.307.223.117-.361-.307-.223h.379l.117-.361.117.361h.381Z",
    style: {
      fill: "#046a38"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.344,14.586l.126-.389-.331-.24h.409l.126-.389.126.389h.409l-.331.24.126.389-.331-.24-.329.24ZM17.217,13.982l.283.206-.108.333.283-.206.283.206-.108-.333.283-.206h-.35l-.108-.333-.108.333h-.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M18.171,16.03h-.379l-.117.361-.117-.361h-.379l.307-.223-.117-.361.307.223.307-.223-.117.361.305.223Z",
    style: {
      fill: "#046a38"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.675,16.432l-.126-.389h-.409l.331-.24-.126-.389.331.24.331-.24-.126.389.331.24h-.409l-.128.389ZM17.567,16.018l.108.333.108-.333h.35l-.283-.206.108-.333-.283.206-.283-.206.108.333-.283.206h.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M16.96,17.698l-.307-.223-.307.223.117-.361-.307-.223h.379l.117-.361.117.361h.379l-.307.223.119.361Z",
    style: {
      fill: "#046a38"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.984,17.73l-.331-.24-.331.24.126-.389-.331-.24h.409l.126-.389.126.389h.409l-.331.24.128.389ZM16.653,17.459l.283.206-.108-.333.283-.206h-.35l-.108-.333-.108.333h-.35l.283.206-.108.333.283-.206Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a5",
    "data-name": "a",
    d: "M15,18.335l-.117-.361h-.379l.307-.223-.117-.361.306.223.307-.223-.117.361.307.223h-.379l-.118.361Z",
    style: {
      fill: "#046a38"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15,18.375l-.126-.389h-.409l.331-.24-.126-.389.331.24.331-.24-.126.389.331.24h-.409l-.128.389ZM14.542,17.961h.35l.108.333.108-.333h.35l-.283-.206.108-.333-.283.207-.283-.206.108.333-.283.205Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a6",
    "data-name": "a",
    d: "M13.04,17.698l.117-.361-.307-.223h.379l.117-.361.117.361h.379l-.307.223.117.361-.307-.223-.305.223Z",
    style: {
      fill: "#046a38"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.016,17.73l.126-.389-.331-.24h.409l.126-.389.126.389h.409l-.331.24.126.389-.331-.24-.329.24ZM12.889,17.127l.283.206-.108.333.283-.206.283.206-.108-.333.283-.206h-.35l-.108-.333-.108.333h-.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a7",
    "data-name": "a",
    d: "M11.829,16.03l.307-.223-.117-.361.307.223.307-.223-.117.361.307.223h-.379l-.117.361-.117-.361h-.381Z",
    style: {
      fill: "#046a38"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.325,16.432l-.126-.389h-.409l.331-.24-.126-.389.331.24.331-.24-.126.389.331.24h-.409l-.128.389ZM11.867,16.018h.35l.108.333.108-.333h.35l-.283-.206.108-.333-.283.206-.283-.206.108.333-.283.206Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a8",
    "data-name": "a",
    d: "M11.829,13.97h.379l.117-.361.117.361h.379l-.307.223.117.361-.307-.223-.307.223.117-.361-.305-.223Z",
    style: {
      fill: "#046a38"
    }
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.656,14.586l-.331-.24-.331.24.126-.389-.331-.24h.409l.126-.389.126.389h.409l-.331.24.128.389ZM12.325,14.315l.283.206-.108-.333.283-.206h-.35l-.108-.333-.108.333h-.35l.283.206-.108.333.283-.206Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a9",
    "data-name": "a",
    d: "M13.04,12.302l.307.223.307-.223-.117.361.307.223h-.379l-.117.361-.117-.361h-.381l.307-.223-.117-.361Z",
    style: {
      fill: "#046a38"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.347,13.287l-.126-.389h-.409l.331-.24-.126-.389.331.24.331-.24-.126.389.331.24h-.409l-.128.389ZM13.239,12.873l.108.333.108-.333h.35l-.283-.206.108-.333-.283.206-.283-.206.108.333-.283.206h.35Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.54,
    cy: 16.012,
    rx: 0.225,
    ry: 1.104,
    transform: "translate(-1.08 1.124) rotate(-4.002)",
    style: {
      fill: "#046a38"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.588,17.1c-.08,0-.145-.172-.185-.317-.057-.206-.1-.481-.12-.776-.021-.295-.017-.573.011-.785.02-.152.061-.334.143-.34h.004c.08,0,.145.172.185.317.057.206.1.481.12.776.021.295.017.573-.011.785-.02.152-.061.334-.143.34h-.004ZM15.44,14.897h-.003c-.055.004-.102.123-.129.327-.028.211-.032.488-.011.782s.063.568.12.773c.055.198.118.31.174.306.055-.004.102-.123.129-.327.028-.211.032-.488.011-.782s-.063-.568-.12-.773c-.054-.195-.116-.306-.171-.306Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.759,
    cy: 16.009,
    rx: 0.238,
    ry: 1.104,
    transform: "translate(-1.079 1.139) rotate(-4.002)",
    style: {
      fill: "#046a38"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.807,17.098c-.066,0-.134-.112-.194-.316-.059-.205-.104-.481-.124-.776-.043-.622.03-1.116.167-1.126h.004c.136,0,.275.476.318,1.092h0c.043.622-.03,1.116-.167,1.126h-.004ZM15.66,14.894h-.003c-.124.009-.195.517-.153,1.11.021.294.064.568.124.772.057.198.123.309.183.306.124-.009.195-.517.153-1.11h0c-.042-.587-.18-1.078-.304-1.078Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.657,
    cy: 16.068,
    rx: 0.19,
    ry: 1.221,
    transform: "translate(-1.083 1.132) rotate(-4.002)",
    style: {
      fill: "#046a38"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.714,17.273c-.122,0-.238-.613-.28-1.211-.023-.326-.024-.633-.005-.866.014-.167.046-.368.116-.373.069-.005.129.189.166.353.052.228.093.533.116.858.023.326.024.633.005.866-.014.167-.046.368-.116.373h-.002ZM15.548,14.837h-.002c-.045.003-.083.138-.102.359-.02.232-.018.539.005.864.05.72.177,1.198.265,1.198h.002c.045-.003.083-.138.102-.359.02-.232.018-.539-.005-.864s-.064-.629-.115-.856c-.05-.214-.105-.342-.15-.342Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.915,16.808c-.335.035-1.802.052-1.865.006s-.156-.24-.156-.25c.192-.008.108-.11.206-.165.096-.056.233-.019.275.048.042.069.008.135.06.137.054,0,1.096-.05,1.479-.023.062.004.11.06.11.123s-.047.118-.109.124Z",
    style: {
      fill: "#9c4a00"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.702,16.849c-.343,0-.628-.008-.657-.029-.065-.048-.159-.243-.159-.256v-.007h.007c.112-.005.125-.041.141-.083.01-.027.022-.058.062-.081.098-.058.241-.02.285.05.019.032.023.063.026.088.004.032.006.045.028.046.009,0,.053-.002.118-.004.286-.011,1.047-.041,1.361-.019.065.004.117.063.117.13,0,.066-.051.124-.117.13-.177.02-.747.035-1.212.035ZM13.903,16.571c.015.038.096.197.151.237.058.042,1.518.028,1.86-.008h0c.058-.006.104-.057.104-.116,0-.06-.046-.112-.104-.116-.313-.022-1.073.008-1.359.019-.066.003-.109.004-.119.004-.035,0-.039-.028-.042-.059-.003-.024-.006-.053-.024-.082-.04-.065-.173-.099-.265-.045-.036.02-.046.046-.056.073-.017.043-.033.086-.146.093Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M14.915,16.704c-.002.146.21.104.215.225-.006.127-.358.008-.363-.227.015-.233.358-.348.363-.215.003.111-.211.073-.215.217Z",
    style: {
      fill: "#ffcd00"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.058,16.988h-.003c-.116-.002-.293-.117-.296-.286.011-.174.197-.279.297-.279h.002c.049,0,.077.024.078.064.002.057-.049.078-.099.099-.056.023-.113.047-.115.118-.001.072.052.094.109.119.051.022.104.044.106.106-.002.038-.031.059-.079.059ZM15.056,16.438c-.095,0-.272.099-.282.264.003.165.184.27.282.271h.002c.024,0,.062-.006.064-.045-.002-.052-.048-.072-.097-.093-.056-.024-.119-.051-.118-.132h0c.002-.081.067-.108.124-.131.049-.02.092-.038.09-.085-.001-.042-.041-.049-.064-.05t0,.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d1",
    "data-name": "d",
    d: "M15.04,16.704c-.002.146.21.104.215.225-.006.127-.358.008-.363-.227.015-.233.358-.348.363-.215.003.111-.211.073-.215.217Z",
    style: {
      fill: "#ffcd00"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.183,16.988h-.003c-.116-.002-.293-.117-.296-.286.011-.174.197-.279.297-.279h.002c.049,0,.077.024.078.064.002.057-.049.078-.099.099-.056.023-.113.047-.115.118-.001.072.052.094.109.119.051.022.104.044.106.106-.002.038-.031.059-.079.059ZM15.181,16.438c-.095,0-.272.099-.282.264.003.165.184.27.282.271.023,0,.064-.005.066-.045-.002-.052-.048-.072-.097-.093-.056-.024-.119-.051-.118-.132h0c.002-.081.067-.108.124-.131.049-.02.092-.038.09-.085-.001-.042-.041-.049-.064-.05t0,.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d2",
    "data-name": "d",
    d: "M15.175,16.704c-.002.146.21.104.215.225-.006.127-.358.008-.363-.227.015-.233.358-.348.363-.215.004.111-.211.073-.215.217Z",
    style: {
      fill: "#ffcd00"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.319,16.988h-.003c-.116-.002-.293-.117-.296-.286.011-.174.197-.279.297-.279h.002c.049,0,.077.024.078.064.002.057-.049.078-.099.099-.056.023-.113.047-.115.118-.001.072.052.094.109.119.051.022.104.044.106.106-.003.038-.031.059-.079.059ZM15.316,16.438c-.095,0-.272.099-.282.264.003.165.184.27.282.271.024,0,.064-.005.066-.045-.002-.052-.048-.072-.097-.093-.056-.024-.119-.051-.118-.132h0c.002-.081.067-.108.124-.131.049-.02.092-.038.09-.085-.001-.042-.041-.049-.064-.05.001.001,0,.001,0,.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d3",
    "data-name": "d",
    d: "M15.302,16.704c-.002.146.21.104.215.225-.006.127-.358.008-.363-.227.015-.233.358-.348.363-.215.004.111-.211.073-.215.217Z",
    style: {
      fill: "#ffcd00"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.446,16.988h-.003c-.116-.002-.293-.117-.296-.286.011-.174.197-.279.297-.279h.002c.049,0,.077.024.078.064.002.057-.049.078-.099.099-.056.023-.113.047-.115.118-.001.072.052.094.109.119.051.022.104.044.106.106-.003.038-.031.059-.079.059ZM15.443,16.438c-.095,0-.272.099-.282.264.003.165.184.27.282.271.024,0,.064-.005.066-.045-.002-.052-.048-.072-.097-.093-.056-.024-.119-.051-.118-.132h0c.002-.081.067-.108.124-.131.049-.02.092-.038.09-.085-.001-.042-.041-.049-.064-.05.001.001,0,.001,0,.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.248,16.125c.044.105.046.255.004.335s-.112.06-.157-.045c-.044-.105-.046-.255-.004-.335.043-.08.113-.06.157.045Z",
    style: {
      fill: "#046a38"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.189,16.597h-.005c-.04-.002-.116-.023-.169-.147-.055-.13-.055-.306-.001-.41.047-.09.118-.097.146-.096.04.002.116.023.169.147.055.13.055.306.001.41-.045.085-.11.096-.141.096ZM15.16,16.143c-.018.059-.016.162.016.238.003.006.005.011.008.016.018-.059.016-.162-.016-.238-.003-.006-.005-.011-.008-.016Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.064,16.112c.044.105.046.255.004.335s-.112.06-.157-.045-.046-.255-.004-.335c.043-.08.113-.06.157.045Z",
    style: {
      fill: "#046a38"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.005,16.584h-.005c-.04-.002-.116-.023-.169-.147-.055-.13-.055-.306-.001-.41.047-.09.118-.097.146-.096.04.002.116.023.169.147.055.13.055.306.001.41-.045.085-.11.096-.141.096ZM14.976,16.13c-.018.059-.016.162.016.238.003.006.005.011.008.016.018-.059.016-.162-.016-.238-.003-.006-.005-.011-.008-.016Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.933,15.874c.044.105.046.255.004.335s-.112.06-.157-.044c-.044-.105-.046-.255-.004-.335.042-.081.112-.061.157.044Z",
    style: {
      fill: "#046a38"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.873,16.346h-.005c-.04-.002-.116-.023-.169-.147-.055-.13-.055-.306-.001-.41.047-.09.118-.097.146-.096.04.002.116.023.169.147.055.13.055.306.001.41-.045.085-.11.096-.141.096ZM14.844,15.892c-.018.059-.016.162.016.238.003.006.005.012.008.016.018-.059.016-.162-.016-.238h0c-.003-.006-.005-.011-.008-.016Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.132,15.913c.032.135.018.287-.032.341-.05.053-.116-.013-.148-.148s-.018-.287.032-.341.116.013.148.148Z",
    style: {
      fill: "#046a38"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.064,16.359c-.011,0-.023,0-.034-.004-.074-.02-.132-.101-.163-.229-.034-.144-.027-.335.053-.421.037-.039.086-.055.135-.042.074.02.132.101.163.229h0c.034.144.027.335-.053.421-.029.031-.064.046-.101.046ZM15.03,15.877c-.009.049-.012.125.008.209.005.023.012.042.018.056.009-.049.012-.125-.008-.209h0c-.006-.023-.012-.041-.018-.056Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.065,15.689c.036.121.027.27-.02.333-.047.063-.115.016-.151-.104s-.027-.27.02-.333c.048-.064.115-.017.151.104Z",
    style: {
      fill: "#046a38"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.999,16.138c-.008,0-.016,0-.024-.002-.073-.013-.131-.081-.164-.193-.038-.126-.039-.313.034-.41.036-.048.087-.07.14-.061.073.013.131.081.164.193.038.126.039.313-.034.41-.03.04-.072.063-.116.063ZM14.969,15.678c-.012.052-.014.135.01.214.004.014.009.026.013.036.012-.052.014-.135-.01-.214h0c-.005-.014-.009-.026-.013-.036Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.901,15.616c.036.121.027.27-.02.333-.047.063-.115.016-.151-.104-.036-.121-.027-.27.02-.333.048-.064.115-.017.151.104Z",
    style: {
      fill: "#046a38"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.835,16.065c-.008,0-.016,0-.024-.002-.073-.013-.131-.081-.164-.193-.038-.126-.039-.313.034-.41.036-.048.087-.07.14-.061.073.013.131.081.164.193.038.126.039.313-.034.41-.03.04-.072.063-.116.063ZM14.804,15.606c-.012.052-.014.135.01.214.004.014.009.026.013.035.012-.052.014-.135-.01-.214-.004-.014-.008-.026-.013-.035Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.631,13.683s-.367.317-.325,1.177c.046.867.81,1.273.81,1.273h.121v-2.45h-.606Z",
    style: {
      fill: "#9063cd"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.245,16.141h-.132c-.008-.005-.769-.419-.814-1.28-.041-.854.324-1.18.328-1.183l.002-.002h.616v2.465ZM15.119,16.126h.112v-2.435h-.596c-.029.027-.36.356-.321,1.169.044.834.766,1.245.805,1.266Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.535,16.104c.043.078.043.228,0,.335s-.113.13-.156.052-.043-.228,0-.335.113-.13.156-.052Z",
    style: {
      fill: "#046a38"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.439,16.625c-.055,0-.105-.033-.137-.091-.056-.102-.058-.278-.004-.41.052-.127.128-.15.168-.153.059-.004.112.03.146.091h0c.056.101.058.278.004.41-.051.127-.127.15-.168.153h-.009ZM15.468,16.171c-.003.005-.006.011-.008.019-.031.077-.032.178-.015.236.003-.005.006-.011.008-.019.031-.077.033-.178.015-.236Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.357,16.059c.043.078.043.228,0,.335s-.113.13-.156.052-.043-.228,0-.335.113-.13.156-.052Z",
    style: {
      fill: "#046a38"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.262,16.58c-.055,0-.105-.033-.137-.092-.056-.101-.058-.278-.004-.41.051-.127.127-.15.168-.153.059-.003.112.03.146.091h0c.056.101.058.278.004.41-.052.127-.128.15-.168.153-.004,0-.007,0-.009,0ZM15.291,16.125c-.003.005-.006.011-.008.019-.031.077-.032.178-.015.236.003-.005.006-.011.008-.019.031-.077.032-.178.015-.236Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.269,15.805c.043.078.043.228,0,.335s-.113.13-.156.052-.043-.228,0-.335.113-.131.156-.052Z",
    style: {
      fill: "#046a38"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.173,16.326c-.055,0-.105-.033-.137-.092-.056-.101-.058-.278-.004-.41.051-.127.127-.15.168-.153.059-.003.112.03.146.091h0c.056.101.058.278.004.41-.052.127-.128.15-.168.153-.003,0-.006,0-.009,0ZM15.202,15.871c-.003.005-.006.011-.008.019-.031.077-.032.178-.015.236.003-.005.006-.011.008-.019.032-.077.033-.178.015-.236Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.429,15.768c.052.049.07.201.041.339-.029.138-.095.21-.147.161s-.07-.201-.041-.339.096-.21.147-.161Z",
    style: {
      fill: "#046a38"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.358,16.371c-.034,0-.067-.014-.094-.039-.085-.08-.098-.272-.066-.42.016-.076.058-.209.158-.24.047-.015.096-.003.134.033.085.08.098.272.066.42-.016.076-.058.209-.158.24-.013.004-.027.006-.04.006ZM15.388,15.881c-.007.017-.014.039-.02.066-.018.084-.014.16-.003.208.007-.017.014-.039.02-.066.017-.084.013-.16.003-.208Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.69,15.844c.048.059.06.207.027.331-.034.124-.1.177-.148.118-.048-.059-.06-.207-.027-.331.033-.124.1-.176.148-.118Z",
    style: {
      fill: "#046a38"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.611,16.405c-.041,0-.081-.02-.111-.056-.076-.093-.08-.276-.043-.409.031-.116.089-.188.161-.203.052-.011.102.008.139.053h0c.076.093.08.276.043.409-.031.116-.089.188-.161.203-.009.002-.019.003-.028.003ZM15.64,15.944c-.005.011-.009.025-.014.041-.021.077-.019.158-.008.208.005-.011.009-.025.014-.041.021-.077.019-.157.008-.208Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.567,15.734c.048.059.06.207.027.331-.034.124-.1.177-.148.118s-.06-.207-.027-.331.1-.177.148-.118Z",
    style: {
      fill: "#046a38"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15.488,16.294c-.041,0-.081-.02-.111-.056-.076-.093-.08-.276-.043-.409.031-.116.089-.188.161-.203.052-.011.102.008.139.053h0c.076.093.08.276.043.409-.031.116-.089.188-.161.203-.009.002-.019.003-.028.003ZM15.517,15.833c-.005.011-.009.025-.014.041-.021.077-.019.158-.008.208.005-.011.009-.025.014-.041.021-.077.019-.157.008-.208Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.412,15.58c.048.059.06.207.027.331-.034.124-.1.177-.148.118s-.06-.207-.027-.331c.034-.124.1-.177.148-.118Z",
    style: {
      fill: "#046a38"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.334,16.14c-.041,0-.081-.02-.111-.056-.076-.093-.08-.276-.043-.409.031-.116.089-.188.161-.203.052-.011.102.008.139.053.076.093.08.276.043.409-.031.116-.089.188-.161.203-.01.002-.019.003-.028.003ZM15.362,15.68c-.005.011-.009.025-.014.041-.021.077-.019.158-.008.208.005-.011.009-.025.014-.041.022-.077.02-.158.008-.208Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.262,15.479c.048.059.06.207.027.331s-.1.177-.148.118-.06-.207-.027-.331c.033-.124.1-.177.148-.118Z",
    style: {
      fill: "#046a38"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.183,16.039c-.041,0-.081-.02-.111-.056-.076-.093-.08-.276-.043-.409.031-.116.089-.188.161-.203.052-.011.102.008.139.053h0c.076.093.08.276.043.409-.031.116-.089.188-.161.203-.009.002-.018.003-.028.003ZM15.212,15.579c-.005.011-.009.025-.014.041-.021.077-.019.158-.008.208.005-.011.009-.025.014-.041.021-.077.019-.158.008-.208Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.38,
    cy: 15.185,
    rx: 0.308,
    ry: 0.95,
    transform: "translate(-4.779 7.391) rotate(-23.497)",
    style: {
      fill: "#d50032"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.745,16.045c-.165,0-.431-.319-.623-.759-.21-.482-.252-.931-.094-1,.077-.034.189.026.316.169.125.142.25.348.351.581s.167.465.185.653c.018.19-.014.313-.091.346-.014.007-.029.01-.044.01ZM15.074,14.285c-.015,0-.029.003-.042.008-.154.067-.11.51.098.989s.502.813.656.746c.074-.032.104-.152.086-.338-.018-.187-.084-.419-.185-.651-.101-.232-.225-.438-.35-.579-.101-.114-.193-.175-.263-.175Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.146,
    cy: 13.975,
    rx: 0.128,
    ry: 0.112,
    style: {
      fill: "#046a38"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.146,14.174c-.119,0-.215-.089-.215-.199s.096-.199.215-.199.215.089.215.199c0,.109-.097.199-.215.199ZM15.146,13.951c-.024,0-.04.014-.04.024s.016.024.04.024.04-.014.04-.024-.016-.024-.04-.024Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.13,
    cy: 13.835,
    rx: 0.128,
    ry: 0.112,
    style: {
      fill: "#046a38"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15.13,14.034c-.119,0-.215-.089-.215-.199s.096-.199.215-.199.215.089.215.199-.096.199-.215.199ZM15.13,13.811c-.024,0-.04.014-.04.024s.016.024.04.024.04-.014.04-.024-.015-.024-.04-.024Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 14.953,
    cy: 14.003,
    r: 0.12,
    style: {
      fill: "#046a38"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M14.953,14.209c-.114,0-.207-.092-.207-.206s.093-.206.207-.206.207.092.207.206-.093.206-.207.206ZM14.953,13.972c-.018,0-.032.014-.032.031s.014.031.032.031.032-.014.032-.031-.014-.031-.032-.031Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 14.99,
    cy: 13.851,
    r: 0.12,
    style: {
      fill: "#046a38"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14.99,14.055c-.114,0-.207-.092-.207-.204,0-.113.093-.204.207-.204s.207.092.207.204-.093.204-.207.204ZM14.99,13.821c-.018,0-.032.013-.032.029s.014.029.032.029.032-.013.032-.029c0-.015-.015-.029-.032-.029Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.792,
    cy: 13.854,
    rx: 0.135,
    ry: 0.119,
    style: {
      fill: "#046a38"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M14.792,14.06c-.123,0-.223-.092-.223-.206s.1-.206.223-.206.223.092.223.206c0,.114-.1.206-.223.206ZM14.792,13.823c-.027,0-.048.016-.048.031s.02.031.048.031c.027,0,.048-.016.048-.031s-.021-.031-.048-.031Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.039,
    cy: 13.658,
    rx: 0.128,
    ry: 0.112,
    style: {
      fill: "#046a38"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M15.039,13.857c-.119,0-.215-.089-.215-.199s.096-.199.215-.199.215.089.215.199c0,.109-.096.199-.215.199ZM15.039,13.634c-.024,0-.04.014-.04.024s.016.024.04.024.04-.014.04-.024-.015-.024-.04-.024Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 14.87,
    cy: 13.679,
    r: 0.12,
    style: {
      fill: "#046a38"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M14.87,13.883c-.114,0-.207-.092-.207-.204s.093-.204.207-.204.207.092.207.204-.093.204-.207.204ZM14.87,13.65c-.018,0-.032.013-.032.029s.014.029.032.029.032-.013.032-.029-.014-.029-.032-.029Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 14.615,
    cy: 13.861,
    r: 0.12,
    style: {
      fill: "#046a38"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M14.615,14.068c-.114,0-.207-.092-.207-.206s.093-.206.207-.206.207.092.207.206c0,.113-.093.206-.207.206ZM14.615,13.83c-.018,0-.032.014-.032.031s.014.031.032.031.032-.014.032-.031c0-.017-.015-.031-.032-.031Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 14.656,
    cy: 13.773,
    r: 0.12,
    style: {
      fill: "#046a38"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M14.656,13.977c-.114,0-.207-.092-.207-.204,0-.113.093-.204.207-.204s.207.092.207.204c.001.112-.092.204-.207.204ZM14.656,13.743c-.018,0-.032.013-.032.029s.014.029.032.029.032-.013.032-.029c.001-.015-.014-.029-.032-.029Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 14.706,
    cy: 13.674,
    r: 0.12,
    style: {
      fill: "#046a38"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M14.706,13.878c-.114,0-.207-.092-.207-.204s.093-.204.207-.204.207.092.207.204-.093.204-.207.204ZM14.706,13.644c-.018,0-.032.013-.032.029s.014.029.032.029.032-.013.032-.029-.014-.029-.032-.029Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.472,
    cy: 15.039,
    rx: 0.392,
    ry: 1.131,
    transform: "translate(-4.753 7.522) rotate(-23.797)",
    style: {
      fill: "#046a38"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M15.895,16.069c-.092,0-.207-.071-.333-.206-.154-.166-.307-.41-.429-.688-.122-.277-.2-.554-.218-.781-.019-.229.025-.379.124-.422.099-.044.239.025.395.193.154.166.307.41.429.688.122.277.2.554.218.781.019.229-.025.379-.124.422-.019.009-.04.013-.062.013ZM15.102,13.975c-.021,0-.04.004-.057.012-.093.041-.134.186-.115.408.018.225.096.5.217.776.122.276.273.518.426.684.152.163.286.231.379.19.093-.041.134-.186.115-.408-.018-.225-.096-.5-.217-.776-.122-.276-.273-.518-.426-.684-.123-.133-.235-.202-.322-.202Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.796,
    cy: 15.219,
    rx: 0.075,
    ry: 0.238,
    transform: "translate(-4.798 7.667) rotate(-23.797)",
    style: {
      fill: "#046a38"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M15.907,15.422c-.049,0-.117-.095-.16-.194-.048-.109-.072-.236-.024-.257.049-.021.126.082.174.191h0c.048.109.072.236.024.257-.005.002-.01.003-.014.003ZM15.736,14.983s-.005,0-.007,0c-.029.013-.024.114.031.238.055.124.125.196.155.183.029-.013.024-.114-.031-.238-.051-.113-.115-.184-.148-.184Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.788,15.196c.319.39.279.637.246.846l-.452-.485v-.488l.206.127Z",
    style: {
      fill: "#046a38"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M16.038,16.058l-.464-.498v-.503l.219.136c.321.392.28.647.247.852l-.002.013ZM15.589,15.553l.44.472c.033-.209.063-.447-.246-.824l-.194-.12s0,.472,0,.472Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.815,15.51c.321.39.281.637.248.846l-.615-.952v-.64c.048.126.048.357.367.746Z",
    style: {
      fill: "#046a38"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M16.067,16.376l-.626-.97v-.681l.014.037c.01.027.018.059.028.095.035.137.088.343.338.648.323.392.282.647.249.852l-.003.019ZM15.455,15.402l.603.934c.033-.208.06-.446-.249-.821h0c-.252-.308-.305-.516-.341-.654-.005-.018-.009-.035-.013-.05,0,0,0,.591,0,.591Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.825,15.765c.327.381.292.631.262.842-.104-.24-.162-.392-.492-.775-.327-.383-.173-.66-.154-.804.053.122.057.353.384.737Z",
    style: {
      fill: "#046a38"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M16.091,16.632l-.011-.023-.014-.031c-.095-.218-.163-.376-.477-.742-.275-.322-.214-.566-.174-.727.008-.032.015-.059.018-.083l.005-.026.01.025c.012.027.021.06.032.098.038.135.096.34.351.638h0c.329.383.293.64.264.846l-.004.025ZM15.444,15.055c-.004.018-.008.037-.014.058-.04.159-.099.398.171.714.315.367.384.526.479.745l.003.008c.028-.209.047-.447-.264-.81h0c-.256-.3-.315-.507-.354-.643-.007-.027-.013-.051-.021-.072Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.587,
    cy: 14.823,
    rx: 0.138,
    ry: 0.421,
    transform: "translate(-4.804 7.976) rotate(-24.999)",
    style: {
      fill: "#046a38"
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M15.755,15.22c-.077,0-.197-.136-.288-.332-.101-.218-.123-.415-.05-.449.036-.017.089.009.149.072.058.062.116.152.164.255.048.103.08.205.09.289.01.086-.004.143-.04.16-.009.004-.017.005-.025.005ZM15.441,14.449c-.006,0-.012,0-.018.004-.064.03-.038.227.057.43s.229.35.293.32c.03-.014.041-.067.032-.145-.01-.082-.041-.183-.089-.284-.047-.101-.104-.19-.161-.251-.045-.049-.085-.074-.114-.074Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.462,
    cy: 15.042,
    rx: 0.121,
    ry: 0.346,
    transform: "translate(-4.82 7.695) rotate(-24.299)",
    style: {
      fill: "#046a38"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M15.594,15.37c-.067,0-.167-.112-.24-.274-.081-.18-.094-.345-.029-.375.032-.015.078.006.128.059.048.051.096.125.134.21h0c.081.18.094.345.029.375-.007.004-.015.005-.022.005ZM15.347,14.732c-.006,0-.011,0-.016.003-.056.025-.04.188.036.355s.187.287.243.262c.056-.025.04-.188-.036-.355h0c-.038-.083-.084-.157-.132-.206-.036-.038-.07-.059-.095-.059Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.293,
    cy: 15.172,
    rx: 0.121,
    ry: 0.346,
    transform: "translate(-4.74 7.251) rotate(-23.199)",
    style: {
      fill: "#046a38"
    }
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M15.437,15.521c-.067,0-.166-.114-.236-.278-.037-.086-.06-.171-.064-.241-.005-.072.01-.12.043-.134s.078.008.127.061c.047.052.093.127.13.213h0c.078.182.087.347.021.375-.007.003-.014.004-.021.004ZM15.2,14.878c-.005,0-.01,0-.015.003-.026.011-.039.055-.034.12.005.068.027.152.063.236.072.169.181.291.238.266.057-.024.043-.187-.029-.356h0c-.036-.084-.081-.158-.128-.209-.036-.039-.07-.06-.095-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.459,
    cy: 14.63,
    rx: 0.096,
    ry: 0.265,
    transform: "translate(-5.059 8.971) rotate(-28.003)",
    style: {
      fill: "#046a38"
    }
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M15.55,14.903c-.054,0-.135-.079-.197-.197-.034-.063-.056-.127-.064-.181-.008-.056.002-.094.027-.108.025-.014.063,0,.105.038.04.036.081.091.114.154s.056.127.064.181c.008.056-.002.094-.027.108-.007.003-.015.005-.022.005ZM15.338,14.427c-.006,0-.011,0-.015.003-.019.01-.027.044-.02.093.007.052.029.114.062.176.072.136.161.206.199.186.019-.01.027-.044.02-.093-.007-.052-.029-.114-.062-.176h0c-.033-.062-.072-.115-.111-.15-.029-.025-.054-.039-.073-.039Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.312,
    cy: 14.766,
    rx: 0.096,
    ry: 0.265,
    transform: "translate(-4.732 7.644) rotate(-24.399)",
    style: {
      fill: "#046a38"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M15.409,15.008c-.024,0-.053-.016-.083-.048-.038-.039-.075-.096-.104-.161-.03-.065-.048-.131-.052-.184-.004-.056.008-.094.034-.106.053-.024.143.066.206.205h0c.03.065.048.131.052.184.004.056-.008.094-.034.106-.006.003-.013.004-.019.004ZM15.221,14.52c-.005,0-.009,0-.012.003-.02.009-.029.042-.025.091.004.052.022.116.051.18.029.064.065.119.101.157.034.035.065.05.085.041s.029-.042.025-.091c-.004-.052-.022-.116-.051-.18h0c-.057-.128-.131-.201-.174-.201Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M15.915,16.816c-.072,0-.13-.058-.13-.13s.058-.13.13-.13c.004,0,.007.003.007.007s-.003.007-.007.007c-.064,0-.116.052-.116.116s.052.116.116.116c.004,0,.007.003.007.007s-.003.007-.007.007Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.044,14.696c.095.231.21.399.257.374s.009-.232-.086-.464",
    style: {
      fill: "#046a38"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M15.291,15.08s-.009,0-.014-.003c-.059-.021-.157-.177-.239-.378-.002-.004,0-.008.004-.01.004,0,.008,0,.009.004.08.195.177.351.231.37.006.002.012.002.016,0,.038-.02.01-.211-.089-.455-.002-.004,0-.008.004-.01.004,0,.008,0,.009.004.084.206.142.442.083.473-.005.004-.01.005-.014.005Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.296,
    cy: 14.494,
    rx: 0.096,
    ry: 0.265,
    transform: "translate(-4.621 7.613) rotate(-24.399)",
    style: {
      fill: "#046a38"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M15.393,14.736c-.054,0-.132-.085-.188-.209-.063-.139-.071-.266-.018-.29s.143.066.206.205h0c.063.139.071.266.018.29-.005.003-.011.004-.018.004ZM15.205,14.248c-.005,0-.009,0-.012.003-.039.018-.038.131.026.271s.148.215.187.198c.039-.018.038-.131-.026-.271-.058-.128-.132-.201-.175-.201Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.116,
    cy: 14.541,
    rx: 0.096,
    ry: 0.265,
    transform: "translate(-4.506 7.13) rotate(-23.199)",
    style: {
      fill: "#046a38"
    }
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M15.23,14.815c-.024,0-.053-.017-.083-.05-.037-.039-.073-.097-.101-.163-.028-.066-.045-.132-.048-.185-.003-.056.01-.094.036-.105.027-.011.062.005.101.046.037.039.073.097.101.163.028.066.045.132.048.185.003.056-.01.094-.036.105-.006.002-.012.004-.018.004ZM15.051,14.322s-.008,0-.012.002c-.02.009-.03.042-.027.091.003.052.02.116.047.181.028.064.062.121.098.159.034.036.064.051.085.043.02-.009.03-.042.027-.091-.003-.052-.02-.116-.047-.181-.028-.064-.062-.121-.098-.159-.028-.029-.053-.045-.073-.045Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.938,14.377c.093.157.193.264.224.241s-.019-.17-.111-.326",
    style: {
      fill: "#046a38"
    }
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M15.151,14.628s-.004,0-.007,0c-.045-.009-.132-.11-.213-.247-.002-.003-.001-.008.003-.01.003-.002.008,0,.01.003.087.147.17.233.204.24.004,0,.007,0,.01,0,.024-.018-.016-.153-.113-.317-.002-.003-.001-.008.003-.01.003-.002.008,0,.01.003.083.14.15.305.11.336-.006.003-.011.004-.017.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.002,14.273c.083.146.18.255.218.243.037-.012.001-.14-.082-.286M15.244,14.327c.128.214.267.361.31.328s-.026-.231-.154-.445",
    style: {
      fill: "#046a38"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M15.54,14.667s-.006,0-.009,0c-.061-.012-.182-.15-.293-.335-.002-.003-.001-.008.002-.01s.008,0,.01.003c.108.179.227.317.284.329.007,0,.012,0,.016-.002.034-.026-.021-.211-.156-.435-.002-.003-.001-.008.002-.01s.008,0,.01.003c.114.19.206.414.152.455-.005.001-.011.003-.018.003ZM15.214,14.524c-.051,0-.148-.124-.218-.247-.002-.003-.001-.008.003-.01.003-.002.008,0,.01.003.087.153.18.249.209.239.002,0,.005-.002.007-.008.012-.03-.016-.132-.093-.268-.002-.004-.001-.008.003-.01.003-.002.008,0,.01.003.072.127.11.24.094.281-.004.01-.011.015-.016.016-.004,0-.006.001-.009.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.1,14.192c.086.164.184.284.219.267s-.005-.164-.091-.328c-.006-.011-.012-.022-.018-.033",
    style: {
      fill: "#046a38"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M15.312,14.468c-.05,0-.147-.135-.218-.273-.002-.004,0-.008.003-.01.004-.002.008,0,.01.003.089.172.182.277.209.264.003,0,.005-.004.006-.008.012-.035-.019-.153-.1-.309-.006-.011-.012-.022-.018-.033-.002-.004-.001-.008.003-.01.004-.002.008,0,.01.003.006.011.012.022.018.033.075.144.116.276.101.321-.003.008-.007.014-.014.017-.003.001-.006.002-.01.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M15.202,13.848c-.06.062.002.175.056.221.065.054.419.431.669.117-.2-.005-.575-.476-.725-.338Z",
    style: {
      fill: "#9063cd"
    }
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M15.694,14.317c-.175,0-.343-.154-.417-.221-.01-.009-.018-.016-.023-.021-.039-.033-.081-.097-.083-.156-.002-.031.007-.056.027-.076h0c.09-.082.252.039.409.157.117.087.237.177.321.179h.015l-.009.012c-.061.077-.134.119-.216.126-.009-.001-.016,0-.024,0ZM15.207,13.853c-.016.017-.024.039-.022.065.003.054.042.115.078.145.006.005.014.012.024.021.075.069.251.231.429.217.074-.006.14-.043.197-.109-.087-.01-.198-.093-.315-.181-.153-.114-.31-.231-.391-.158Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "e1",
    "data-name": "e",
    d: "M15.158,13.662c-.06.062.002.175.056.221.065.054.419.431.669.117-.2-.004-.575-.475-.725-.338Z",
    style: {
      fill: "#9063cd"
    }
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M15.65,14.131c-.175,0-.343-.154-.417-.221-.01-.009-.018-.016-.023-.021-.039-.033-.081-.097-.083-.156-.002-.031.007-.056.027-.076h0c.09-.082.252.039.409.157.117.087.237.177.321.179h.015l-.009.011c-.061.077-.134.119-.216.126-.009.001-.016.001-.024.001ZM15.163,13.668c-.016.017-.024.039-.022.065.003.054.042.115.078.145.006.005.014.012.024.021.075.069.251.231.429.217.074-.006.14-.043.197-.109-.087-.01-.198-.093-.315-.181-.153-.114-.31-.232-.391-.158Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "e2",
    "data-name": "e",
    d: "M15.102,13.485c-.06.062.002.175.056.221.065.054.419.431.669.117-.2-.004-.575-.475-.725-.338Z",
    style: {
      fill: "#9063cd"
    }
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M15.594,13.954c-.175,0-.343-.154-.417-.221-.01-.009-.018-.016-.023-.021-.039-.033-.081-.097-.083-.156-.002-.031.007-.056.027-.076h0c.09-.082.252.039.409.157.117.087.237.177.321.179h.015l-.009.012c-.061.077-.134.119-.216.126h-.024ZM15.107,13.491c-.016.017-.024.039-.022.065.003.054.042.115.078.145.006.005.014.012.024.021.075.069.251.231.429.217.074-.006.14-.043.197-.11-.087-.01-.198-.093-.315-.181-.153-.113-.31-.231-.391-.157Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "e3",
    "data-name": "e",
    d: "M14.979,13.283c-.06.062.002.175.056.221.065.054.419.431.669.117-.2-.004-.575-.475-.725-.338Z",
    style: {
      fill: "#9063cd"
    }
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M15.471,13.752c-.176,0-.344-.154-.417-.221-.01-.009-.018-.016-.023-.021-.039-.033-.081-.097-.083-.156-.002-.031.007-.056.027-.076h0c.09-.082.252.039.409.157.117.087.237.177.321.179h.015l-.009.012c-.061.077-.134.119-.216.126h-.024ZM14.984,13.289c-.016.017-.024.039-.022.065.003.054.042.115.078.145.006.005.014.012.024.021.075.069.252.231.429.217.074-.006.14-.043.197-.109-.087-.01-.198-.093-.315-.181-.153-.114-.31-.232-.391-.158Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.544,13.09c.127-.096.36-.123.542-.031.152.075.404.377.594.45-.133.023-.215.002-.3-.038-.169.121-.229.14-.4.165-.24.033-.438-.029-.508-.152-.072-.119-.041-.307.072-.394Z",
    style: {
      fill: "#9063cd"
    }
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M14.854,13.652c-.183,0-.329-.06-.39-.165-.074-.123-.038-.315.075-.403h0c.119-.09.352-.132.549-.032.068.034.156.112.248.195.118.106.24.215.345.255l.025.01-.026.004c-.133.023-.214.003-.3-.036-.167.119-.229.138-.4.163-.043.006-.085.009-.126.009ZM14.548,13.095c-.107.083-.141.267-.071.384.071.123.267.181.501.149.169-.025.23-.044.397-.163l.003-.002.004.002c.08.037.154.057.271.041-.101-.047-.215-.149-.326-.248-.092-.082-.179-.16-.245-.192-.185-.095-.417-.059-.534.029Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.813,
    cy: 13.278,
    rx: 0.111,
    ry: 0.064,
    style: {
      fill: "#d50032"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M14.813,13.429c-.113,0-.198-.065-.198-.152s.085-.152.198-.152.198.065.198.152-.085.152-.198.152Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.807,
    cy: 13.273,
    rx: 0.038,
    ry: 0.034
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.495,
    cy: 13.543,
    rx: 0.152,
    ry: 0.094,
    transform: "translate(-3.812 5.902) rotate(-20.401)",
    style: {
      fill: "#ffcd00"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M14.434,13.643c-.012,0-.023,0-.034-.003-.036-.007-.061-.025-.07-.051s-.003-.056.02-.085c.022-.028.055-.051.094-.066.039-.015.08-.019.114-.012.036.007.061.025.07.051h0c.01.026.003.056-.02.085-.022.028-.055.051-.094.066-.027.01-.055.015-.08.015ZM14.524,13.438c-.024,0-.05.005-.076.014-.037.014-.068.035-.088.061-.019.025-.025.05-.018.071.008.021.029.036.059.042.032.006.07.002.106-.011.037-.014.068-.035.088-.061.019-.025.025-.05.018-.071h0c-.008-.021-.029-.036-.059-.042-.009-.002-.019-.003-.03-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.571,13.362c.01.048-.025.115-.104.138-.079.033-.14.108-.175.231-.121-.279-.044-.398.085-.427.111-.035.177-.031.194.058Z",
    style: {
      fill: "#ffcd00"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M14.293,13.753l-.008-.019c-.065-.151-.078-.266-.039-.344.024-.048.068-.08.129-.094.078-.025.127-.027.159-.008.022.013.037.037.043.072.011.052-.027.122-.109.146-.079.033-.136.109-.17.226l-.005.021ZM14.481,13.291c-.026,0-.059.007-.102.02-.058.013-.098.042-.12.086-.036.07-.025.175.031.313.036-.11.094-.183.173-.217.075-.022.11-.084.1-.129h0c-.006-.031-.018-.051-.036-.062-.012-.008-.027-.011-.046-.011Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.454,
    cy: 13.425,
    r: 0.027
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDm);
export default __webpack_public_path__ + "static/media/DM.3f57ddfd249ede517cca621eebed7995.svg";
export { ForwardRef as ReactComponent };